
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contract/move_token/create",
      function () {
        return require("private-next-pages/contract/move_token/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contract/move_token/create"])
      });
    }
  